import React from "react";
import useUploadXLS from "./useUploadXLS";
import "./uploadXLS.scss";
import { getTranslateByScope } from "../../../i18n";

export default function UploadXLS() {
  const { onFileUpload } = useUploadXLS();
  const translate = getTranslateByScope("app.currentOrder");

  return (
    <label className="xls-button-label" htmlFor="upload-xsl-button">
      {translate("fileUploadButton")}
      <input
        type="file"
        onChange={onFileUpload}
        onClick={(event) => {
          event.target.value = null;
        }}
        accept={".xls, .xlsx"}
        id="upload-xsl-button"
      />
    </label>
  );
}
